'use strict'

export function normalizeUiLocale(value) {
  if (typeof value !== 'string') return 'zh-CN'

  const locale = value.trim().replace(/_/g, '-').toLowerCase()

  if (locale === 'zh' || locale === 'cn' || locale === 'zh-cn' || locale === 'zh-hans') {
    return 'zh-CN'
  }
  if (locale === 'tw' || locale === 'hk' || locale === 'zh-tw' || locale === 'zh-hk' || locale === 'zh-hant') {
    return 'zh-TW'
  }
  if (locale === 'en' || locale.indexOf('en-') === 0) {
    return 'en'
  }
  if (locale === 'vietnamese' || locale === 'vi-vn') {
    return 'Vietnamese'
  }

  return 'zh-CN'
}

export function toApiLang(value) {
  switch (normalizeUiLocale(value)) {
    case 'zh-TW':
      return 'zh-tw'
    case 'en':
      return 'en'
    case 'Vietnamese':
    case 'zh-CN':
    default:
      return 'zh-cn'
  }
}

export function ensureApiLangParam(params, value) {
  const nextParams = Object.assign({}, params || {})
  const hasLangParam = Object.keys(nextParams).some(key => {
    const normalizedKey = key.toLowerCase()
    return normalizedKey === 'lang' || normalizedKey === 'language'
  })
  if (!hasLangParam) {
    nextParams.lang = toApiLang(value)
  }
  return nextParams
}



// WEBPACK FOOTER //
// ./src/locales/language.js